import api from '@/services/api';
import { acquisitionPayload } from './acquisition';

const measurementId = 'G-D6FLVY401E';
export async function analyticsIdentity() {
  if (navigator.globalPrivacyControl || navigator.doNotTrack === '1' || window.doNotTrack === '1'
      || typeof window.gtag !== 'function') return { allowed: false };
  const cookie = document.cookie.split(';').map(value => value.trim()).find(value => value.startsWith('_ga='));
  const persisted = cookie && /^GA\d+\.\d+\.(\d+\.\d+)$/.exec(cookie.slice(4))?.[1];
  if (!persisted) return { allowed: false };
  const get = field => new Promise(resolve => {
    const timeout = window.setTimeout(() => resolve(null), 400);
    try { window.gtag('get', measurementId, field, value => { window.clearTimeout(timeout); resolve(value); }); }
    catch { window.clearTimeout(timeout); resolve(null); }
  });
  const [client, session] = await Promise.all([get('client_id'), get('session_id')]);
  // Reuse only the SDK's persisted identity; never manufacture one for denied/missing consent.
  if (client !== persisted || !/^\d{1,20}\.\d{1,20}$/.test(client || '') || !/^\d{1,16}$/.test(String(session || ''))) return { allowed: false };
  return { allowed:true, client_id:client, session_id:String(session) };
}

export async function startProCheckout({ plan, from, value }, dependencies = {}) {
  const create = dependencies.create || (body => api.post('/api/user/pro-checkout', body).then(response => response.data));
  const navigate = dependencies.navigate || (url => window.location.assign(url));
  const analytics = await analyticsIdentity();
  const body = { plan, from, ...acquisitionPayload(), analytics, request_id:crypto.randomUUID() };
  const checkout = await create(body);
  const url = new URL(checkout.url);
  if (url.origin !== 'https://checkout.stripe.com') throw new Error('invalid_checkout_destination');
  try { window.gtag?.('event', 'begin_checkout', { currency:'USD', value }); } catch { /* Measurement never blocks checkout. */ }
  navigate(url.href);
}
